// A Kripto Start TAG-szinten nyitott leckéinek száma (SZINTMATRIX). Plusz 2. kör: 85;
// Tananyag 1. kör: + a 9.0 lecke → 86. Ha a DB-ben változik, a landing
// scripts/leckek-1/run-test.mjs leckeszám-esete jelez.
export const TAG_LESSONS = 86;
